var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"h-100 w-100",attrs:{"id":"questionnaireContent","src":this.path,"allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }